<template>
  <div class="village">
    <Banner />
    <div class="box-1 container">
      <div class="title">嘉陵乡镇</div>
      <div class="intro">各乡镇文化动态等信息</div>
      <swiper
        :slidesPerView="6"
        :spaceBetween="30"
        :pagination="{
          clickable: true,
        }"
        navigation
        :modules="modules"
        class="mySwiper"
      >
        <swiper-slide v-for="(v, i) in qyData" :key="v.appcode" :class="[i === index ? 'on' : '']" @click="handelSlide(i)">
          <el-image 
            style="width: 100%; height: 100%"
            :src="isHead(v.logo)" 
            fit="cover">
            <el-image 
              style="width: 100%; height: 100%"
              :src="isHead()" 
              fit="cover">
            </el-image>
          </el-image>
        </swiper-slide>
      </swiper>
    </div>
    <div class="box-2">
      <div style="height: 60px"></div>
      <div class="article-items container flex">
        <List :listData="listData" />
      </div>
      
      <div class="tip-box flex">
      <el-divider v-show="loading && !isOver"><el-button :loading="true">加载中</el-button></el-divider>
      <el-divider v-show="!loading && !isOver"><el-button size="small" @click="getList()">加载更多</el-button></el-divider>
      <el-divider v-show="!loading && isOver">已全部加载</el-divider>
    </div>
      <div style="height: 180px"></div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/5101/index/Banner.vue"
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';

import { Navigation } from "swiper";
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/modules/navigation/navigation.min.css";

import { api } from "@/api"
import { reactive, toRefs } from "vue"
import { isHead } from "@/tools"
import { openInfo } from "@/tools/jump"
import List from "@/components/common/List.vue"
export default {
  name: "village",
  components: {
    Banner,
    Swiper,
    SwiperSlide,
    List
  },
  setup() {
    let initData = reactive({
      index: 0,
      qyData: "",
      loading: false,
      isOver: false,
      page: 1,
      listData: [],

    })
    api("get", "mainLayoutConfig")
      .then(res => {
        if(res.code === 1200) {
          let newData = res.data
          newData.splice(0, 2)
          initData.qyData = newData
          getList()
        }
      })
    function handelSlide(i) {
      initData.index = i
      initData.isOver = false
      initData.loading = false
      initData.page = 1
      initData.listData = []
      getList()
    }
    function getList() {
      initData.loading = true
      api("get", "listortop2", {classid: initData.qyData[initData.index].mainlayout.list_info, istop: 0, pageNum: 1, pageSize: 12})
      // api("get", "listortop2", {classid: '510955', istop: 0, pageNum: 1, pageSize: 12})
        .then(res => {
          initData.loading = false
          if(res.code === 1200) {
            if(res.data) { // 数据存  处理后台返回 null
              if(initData.page == 1) { // 处理掉loading数据
                initData.listData = res.data
              } else {
                initData.listData = [ ...initData.listData, ...res.data]
              }
              // 加载完成
              if(res.data.length < 12) {
                initData.isOver = true
              } else {
                initData.page += 1
              }
            } else {
              initData.isOver = true
            }
          } else {
            initData.isOver = true
          }
        })
        .catch(err => {
          initData.isOver = true
          initData.loading = false

        })
    
    }
    return {
     modules: [ Navigation],
     ...toRefs(initData),
     openInfo,
     isHead,
     handelSlide,
     getList
    }
  }
}
</script>

<style lang="less" scoped>
.box-1 {
  padding-top: 100px;
  padding-bottom: 30px;
  text-align: center;
  line-height: 1;
  background-color: #fff;
  .title {
    font-size: 30px;
  }
  .intro {
    font-size: 16px;
    color: #9EA1A4;
    margin-top: 15px;
  }
}
.mySwiper {
  padding: 0 45px 10px;
  box-sizing: border-box;
  margin-top: 50px;

  &::after {
    content: "";
    width: 45px;
    background-color: #fff;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
  }
  &::before {
    content: "";
    width: 45px;
    background-color: #fff;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
  }
  :deep(.swiper-button-next) {
    color: #1A2E43;
    &::after {
      font-size: 24px;
      font-weight: bold;
    }
  }
  :deep(.swiper-button-prev) {
    color: #1A2E43;
    font-weight: bold;
    &::after {
      font-size: 24px;
    }
  }
  .swiper-slide {
    height: 72px;
    width: 180px;
    cursor: pointer;
  }
  .swiper-slide.on {
    border: 3px solid #10BB58;
    box-sizing: border-box;
    position: relative;
    &::after {
      content: "";
      width: 0px;
				height: 0px;
				border-top: 10px solid #10BB58;
				border-left: 7px solid transparent;
				border-right: 7px solid transparent;
				position: absolute;
				bottom: -10px;
				left: 70px;
        z-index: 1;
    }
  }
}
.box-2 {
  background-color: #F6F6F6;
  .article-items {
    width: 1220px;
    flex-wrap: wrap;
    :deep(.article-box) {
      margin: 40px 10px;
    }
  }
}
.tip-box {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  
}
:deep(.el-divider__text) {
  background-color: #f7f8fa;
  color: #585858;
}
</style>